import Image from 'next/image';
import { WhitePinIcon } from '../../constant/imgImport';
import { TRoleAccess } from '../../constant/storage';
import {
  ICommentSideModal,
  ICommentWrapper,
} from '../../interfaces/components/comment.interface';
import CommentSkeleton from './CommentSkeleton';
import CommentItem from './CommentItem';

const PinnedComment: React.FC<ICommentSideModal & ICommentWrapper> = ({
  toast,
  openConfirm,
  customDataMap,
  useCommentGeneralUtils,
}) => {
  const {
    pinnedComment,
    infinityQueryReturn: { isLoading, isFetching },
    ...interaceAction
  } = useCommentGeneralUtils.usePinnedCommentHook();

  if (!pinnedComment) {
    return null;
  }

  return (
    <div className="mb-8">
      {isLoading || isFetching ? (
        <CommentSkeleton />
      ) : pinnedComment ? (
        <CommentItem
          useCommentGeneralUtils={useCommentGeneralUtils}
          handleUpdateGlobal={interaceAction.updatePinnedComment}
          handleDeleteGlobal={interaceAction.deletePinnedComment}
          handleAddGlobal={interaceAction.placeholderAddComment}
          handleVoteGlobal={interaceAction.votePinnedComment}
          handleTwoWaysPinGlobal={interaceAction.unPinComment}
          customDataMap={customDataMap}
          toast={toast}
          comment={customDataMap(
            pinnedComment,
            pinnedComment?.userRole as TRoleAccess
          )}
          badge={
            <div className="flex items-center justify-between gap-2 bg-success rounded-2xl py-[7px] pr-[10px] pl-[6px] ml-[10px] text-white">
              <Image
                src={WhitePinIcon}
                alt=""
                height={20}
                width={20}
                className="text-white"
              />
              <span className="font-normal text-xs leading-4">Đã ghim</span>
            </div>
          }
          openConfirm={openConfirm}
          isPinned
        />
      ) : null}
    </div>
  );
};

export default PinnedComment;
